import React from "react";
import { Box, Table, Title } from "@allxsmith/bestax-bulma";
import { useSelector} from "react-redux";
import {getContactsData, getDataFresh} from "../../../state/selectors";
import NewJobWorkshopTab from "./NewJobWorkshopTab";
import {useWorkshopsData} from "../../../hooks/useWorkshopsData";
import Spinner from "react-spinner-material";
import WorkshopRow from "./WorkshopRow";
import LoadingSpinner from "../../Utils/Spinner";



function JobWorkshopView(props){
    let params = {}
    let dataFresh = useSelector(getDataFresh);

    let loading = useWorkshopsData(params, dataFresh);
    let workshops = useSelector(getContactsData);

    if (!loading) {
        return (
            <LoadingSpinner/>
        );
    }

    return (
        <div>
            <br/>
            <NewJobWorkshopTab
                dataFresh={dataFresh}
            />
            <br/>
            <Box>
                <details>
                    <summary><Title>Job Tab Workshops</Title></summary>
                <Table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    {workshops.results.map((workshop) => (
                        <WorkshopRow workshop={workshop} dataFresh={dataFresh} />
                    ))}
                </Table>
                </details>
            </Box>
        </div>
    );



}
export default JobWorkshopView;